import React from "react";
import HowItWorksImage from '../../assets/img/howitworks.png';

export default function HowItWorks() {
  const steps = [
    {
      title: "Sign Up & Verify",
      desc: "Create your account, verify your identity, and set up your profile in minutes.",
      icon: "📱",
    },
    {
      title: "Join or Form a Group",
      desc: "Start your own chama or join an existing one with secure digital governance.",
      icon: "👥",
    },
    {
      title: "Save & Contribute",
      desc: "Make contributions, track balances, and automate reminders.",
      icon: "💰",
    },
    {
      title: "Borrow & Lend",
      desc: "Access digital loans, manage repayments, and grow your pool.",
      icon: "📈",
    },
    {
      title: "Transact Seamlessly",
      desc: "Send and receive money via M-PESA and other channels with full transparency.",
      icon: "⚡",
    },
  ];

  return (
    <section className="w-full flex flex-col items-center bg-white py-16 px-4" id="how-it-works">
      <div className="max-w-7xl w-full flex flex-col lg:flex-row items-center gap-12">
        {/* Image */}
        <div className="flex-1 flex justify-center lg:justify-start">
          <img 
            src={HowItWorksImage} 
            alt="How MastaKash works" 
            className="w-full max-w-md lg:max-w-lg rounded-xl shadow-lg"
          />
        </div>

        {/* Steps */}
        <div className="flex-1 flex flex-col gap-6">
          {steps.map((step, index) => (
            <div
              key={index}
              className="flex items-start gap-4 p-5 bg-purple-50 rounded-2xl shadow border border-purple-100"
            >
              <div className="text-3xl">{step.icon}</div>
              <div>
                <h3 className="font-semibold text-purple-900 text-lg">{step.title}</h3>
                <p className="text-gray-600 text-sm mt-1">{step.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>

    </section>
  );
}
